import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';


function CardArranger(props) {
    const results = props.results;
    const render = props.render;
    const columns = props.columns;

    let rowSplit = []
    if (results.length > 0) {
        rowSplit.push([])
    }

    for (const res of results) {
        let last = rowSplit.length - 1
        if (rowSplit[last].length === columns) {
            rowSplit.push([])
            last += 1;
        }
        rowSplit[last].push(res)
    }

    return (
        <Container fluid className='mt-2 p-0'>
            {rowSplit.map((newRow, indexRow) =>
                <Row className='w-100 h-25 mb-2 mt-2' key={indexRow}>
                    {newRow.map((res, index) =>
                        <Col key={index} className='equal-height-col w-25'>
                            {render(res)}
                        </Col>
                    )}
                </Row>
            )
            }
        </Container>
    )
}

export default CardArranger